import React from "react";
import ApiHandler from "../../../Handler/ApiHandler";
import ContentViewComponent from "../../../Component/ContentViewComponent";
import {getRoutePathname} from "../../../Handler/RouteHandler";
import {useDispatch, useSelector} from "react-redux";
import {SnackbarOpen} from "../../../Action/SnackbarAction";
import {Fade, Grid} from "@mui/material";
import ClientBusinessPriceListForm from "./ClientBusinessPriceListComponents/ClientBusinessPriceListForm";
import {useLocation, useParams} from "react-router-dom";

function ClientBusinessPriceList() {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isLoadingContent, setIsLoadingContent] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [clientBusinessPriceList, setClientBusinessPriceList] = React.useState(null);

    React.useEffect(() => {
        if (params.id === 'add') {
            setClientBusinessPriceList(null);

            setBreadcrumbs({
                title: 'Ajouter une grille tarifaire',
                context: 'Gestion Business',
                description: '',
                links: [
                    {path: getRoutePathname('b2b_client_business_price_list'), label: 'Liste des grilles tarifaires'}
                ]
            });
            setTimeout(() => setIsLoadingContent(false), 1500);
        }
        else {
            setClientBusinessPriceList(null);
            setIsLoadingContent(true)
            setBreadcrumbs({
                title: 'Éditer une grille tarifaire',
                context: 'Gestion Business',
                description: '',
                links: [
                    {path: getRoutePathname('b2b_client_business_price_list'), label: 'Liste des grilles tarifaires'}
                ]
            });

            ApiHandler.get({
                route: 'api_b2b_client_business_price_list_get',
                params: {id: params.id}
            }, (response) => {
                if (response.status === 200) {
                    setClientBusinessPriceList(response.data);
                }
                else {
                    dispatch(
                        SnackbarOpen({
                            text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                            variant: 'error',
                        })
                    );
                }
                setIsLoadingContent(false);
            });
        }
    }, [location])

    return (
        <ContentViewComponent loading={isLoadingContent} breadcrumbs={breadcrumbs}>

            <Fade in={true} {...{timeout: 750}}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                   <ClientBusinessPriceListForm clientBusinessPriceList={clientBusinessPriceList}/>
                </Grid>
            </Fade>

            <br/><br/>

        </ContentViewComponent>
    );
}

export default ClientBusinessPriceList;